/**
 * Tickets/ResetPin Controller
 *
 * 
 */

// the constructor for this object
function TicketsResetPinController() { }

// the object
TicketsResetPinController.prototype = {
    constructor: TicketsResetPinController,
    
    // the key to reset the pin
    resetKey: null,
    
    // the account id of the pin to reset
    accountId: null,
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        // register the route variables used by this controller
        this._registerRouteVariables();
        
        PortalHelper.debugMessage('Tickets/ResetPin Controller Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the events used by this controller
        this._registerEvents();
        
        // verify the reset key, and get the new pin
        this.resetPin();
        
        // set the account details
        this._populateAccountDetails();
        
        PortalHelper.debugMessage('Tickets/ResetPin Controller Ran');
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();

        if (segments.length == 2) {
            this.resetKey = segments[0];
            this.accountId = segments[1];
        } else {
            // the uri is missing important pieces
            PortalHelper.sendToDashboard();
        }
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {    
        
    },
    
    
    // validate the pin reset key, and get a new pin
    resetPin: function() 
    {
        var resetPinRequest = new PortalRequest;
        resetPinRequest.makeRequest(
            '/pins/reset-pin',
            {
                reset_key: this.resetKey,
                account_id: this.accountId
            },
            function(data) {
                PortalMain.TicketsResetPinController._populatePinDetails(data);
            },
            function(data, code, message) {
                PortalMain.TicketsResetPinController._setPinError(data);
            }
        );
    },
    
    // populate the account information
    _populateAccountDetails: function()
    {
        // set the account information
        var account = null;
        var accounts = PortalMain.PortalAccounts.getAccounts();
        for (var i in accounts) {
            if (accounts[i].account_id == this.accountId) {
                var account = accounts[i];
            }
        }
        
        $('#account-details .account-number .value').html(account.account_number);
        $('#account-details .account-name .value').html(account.name);
        
        PortalHelper.loadingOverlay('#account-details', false);
    },

    // populate the pin details
    _populatePinDetails: function(data)
    {
        // set the new pin number
        var pin = data.pin;
        $('#new-pin .pin').html(pin);
        
        PortalHelper.loadingOverlay('#new-pin', false);

    },

    // populate the pin error message
    _setPinError: function(data)
    {
        $('#new-pin').addClass('box-error');
        $('#new-pin').attr('data-error-message', 'This PIN reset link has already been used, or is invalid. Use the link below to reset the pin for this account.');
        
        PortalHelper.loadingOverlay('#new-pin', false);

    },
}